module.exports = __webpack_public_path__ + "static/media/cny_2.fe51e4b1.jpg";